import React from "react";
import { useHistory } from "react-router-dom";
import { auth } from "../../firebase/firebaseconfig";
import microsoftProvider from "../../firebase/micosoft.provider";
import { setSessionCookie } from "../../session";

function MicrosoftLoginButton({ setError, fullWidth }) {
  const login = (e) => {
    var allowedDomains = ["bulletline.com","leedsworld.com","pcna.com","powerweave.com","artworkservicesusa.com","polyconcept.com"]
    e.preventDefault();
    const provider = microsoftProvider();
    auth
      .signInWithPopup(provider)
      .then((result) => {
        if (result?.user) {
          var UserDomain = ""

          UserDomain = result.user.email.substring(result.user.email.indexOf("@")+1)

          if(allowedDomains.includes(UserDomain)){
            setSessionCookie({ emailAddr: result.user.email });

            window.location.href = "/home"
          }
          else{
            setError("This email domain is not whitelisted.")
          }
        }
      })
      .catch((err) => {
        if (setError) {
          setError(err.message);
        }
        console.log("Microsoft Login Provider Error : ", err);
      });
  };

  return (
    <a
      className={`btn btn-sm btn-outline-secondary shadow-sm align-self-left d-flex justify-content-center align-items-center px-5 w-100`}
      onClick={login}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        className="mr-5"
      >
        <title>MS-SymbolLockup</title>
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      <span>Microsoft Login</span>
    </a>
  );
}

export default MicrosoftLoginButton;
